import { render, staticRenderFns } from "./SuspenderPrescricoes.vue?vue&type=template&id=7794806a&"
import script from "./SuspenderPrescricoes.vue?vue&type=script&lang=js&"
export * from "./SuspenderPrescricoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports